import { createRequestActionTypes, createActionType } from '../../helpers'

export const FETCH_FAQ = createRequestActionTypes('FAQS', 'QUESTIONS')
export const FETCH_LANDING_CONTENT = createRequestActionTypes(
  'LANDING',
  'CATEGORIES'
)
export const SET_ACTIVE_FAQ = createActionType('FAQS', 'SET_ACTIVE_FAQ')



// WEBPACK FOOTER //
// ./src/containers/FAQs/constants.js